//@ts-check
/**
 * Whether the Me sheet is open, and whether it opens on People. The signed-in layout holds the
 * sheet; anything that needs it — the nav's Me, or Their Things' "Find people to follow" — opens
 * it here.
 */

/** @type {{ open: boolean, people: boolean }} */
export const meSheet = $state({ open: false, people: false });

/** @param {{ people?: boolean }} [options] people: open straight on People */
export function openMe({ people = false } = {}) {
  meSheet.people = people;
  meSheet.open = true;
}

export function closeMe() {
  meSheet.open = false;
  meSheet.people = false;
}
